module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z M6.278 7.697L5.045 6.464a.296.296 0 0 0-.42-.002l-.613.614a.298.298 0 0 0 .002.42l1.91 1.909a.5.5 0 0 0 .703.005l.265-.265L9.997 6.04a.291.291 0 0 0-.009-.408l-.614-.614a.29.29 0 0 0-.408-.009L6.278 7.697z\" fill-rule=\"evenodd\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_status_success_solid.svg
// module id = ../../views/shared/icons/_icon_status_success_solid.svg
// module chunks = pages.projects.issues.show pages.projects.merge_requests.show